var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "dropdown small lc-simple-dropdown" }, [
    _c(
      "button",
      {
        staticClass: "btn btn-secondary dropdown-toggle",
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
        },
      },
      [
        _vm._t(
          "selection",
          function () {
            return [
              _c("span", {
                domProps: {
                  textContent: _vm._s(
                    _vm.displayProp ? _vm.value[_vm.displayProp] : _vm.value
                  ),
                },
              }),
            ]
          },
          { data: _vm.value }
        ),
      ],
      2
    ),
    _c(
      "div",
      { staticClass: "dropdown-menu" },
      [
        _vm.nullable
          ? _c("button", [_vm._v(_vm._s(_vm.placeholder))])
          : _vm._e(),
        _vm._l(_vm.dataSource, function (item, idx) {
          return _c(
            "button",
            {
              key: idx,
              ref: !_vm.changeUrl ? "countrySelector" : "",
              refInFor: true,
              staticClass: "dropdown-item",
              on: {
                click: function ($event) {
                  return _vm.inputChange(item)
                },
              },
            },
            [
              _vm._t(
                "list-item",
                function () {
                  return [
                    _c("span", {
                      domProps: {
                        textContent: _vm._s(
                          _vm.displayProp ? item[_vm.displayProp] : item
                        ),
                      },
                    }),
                  ]
                },
                { data: item }
              ),
            ],
            2
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }